export { default as commentsMock } from './comments.mock.json';
export { default as deleteFacebookCommentMock } from './deleteFacebookComment.mock.json';
export { default as facebookMessagesCommentMock } from './facebookMessages.mock.json';
export { default as facebookPostsMock } from './facebookPosts.mock.json';
export { default as replyCommentsMock } from './replyComments.mock.json';
export { default as instagramPostsMock } from './instagramPosts.mock.json';
export { default as twitterPostsMock } from './twitterPosts.mock.json';
export { default as linkedinPostsMock } from './linkedinPosts.mock.json';
